import React from 'react'
import RightSidebarGlobal from '../../Components/RightSidebarGlobal'
import { UnderlineOutlined } from '@ant-design/icons'
import who_we_are_2 from "../../Assets/images/krisi.png";
import { DOMAIN_NAME } from '../../routes/config';

function OurMission() {
  return (
    <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-12 float-left left_sec searchPageTop">

    <h1>Our Vision</h1>
    <p>"<img src={`${who_we_are_2}`} alt="Benfed" style={{height:20}}/>" i.e. ‘farmer’s friend’  is Our driving force. Our vision is to become an “all weather friend” to the farming 
      community through agriculture co-operatives and its vast member base in the state of West Bengal.</p>

<h2>Our Mission</h2>

<p><strong>We have a three dimensional approach to fulfill our Vision, as noted below:-</strong></p>
    <ul className='list_cus'>
      <li><a href={`${DOMAIN_NAME}fertilizer`}><strong>Supply of Agri-Inputs</strong></a> :- BENFED pledged to supply agriculture 
      inputs i.e. different types of fertilizers of <a href='https://www.iffco.in/en/corporate' target='_blank'>IFFCO</a>, 
      <a href='https://www.indianpotash.org/' target='_blank'>IPL</a>, 
      <a href='https://www.coromandel.biz/' target='_blank'>CIL</a>, <a href='https://hurl.net.in/' target='_blank'>HURL</a>, 
       <a href='https://www.nationalfertilizers.com/' target='_blank'>NFL</a>, <a href='https://www.chambalfertilisers.com/' target='_blank'>CFCL</a>, 
       <a href='https://matixgroup.com/' target='_blank'>MATIX</a>, <a href='https://www.mosaiccoindia.com/' target='_blank'>MOSAIC</a>, 
       <a href='https://jayshreetea.in/' target='_blank'>JCF</a> 
      through the distribution channel of co-operative societies- according to the necessity of Farmer and Soil; following the directive 
      and guideline of Agriculture Department, Government of West Bengal. Avoiding crisis and price stabilization are key parameters to check.</li>

      <li><a href={`${DOMAIN_NAME}marketing-procurement`}><strong>Procurement of Agriculture produces</strong></a>:- 
        BENFED is involved in procurement of agricultural produces (primarily paddy) through agriculture co-operatives under MSP (Minimum Support Price) 
        (MSP Order) operation as part of  various Government schemes maintaining close liaison with all line departments. Ensuring Food Security, Avoiding 
        distress sale and protecting small marginal farmers are key driving force here.</li>

      <li><a href={`${DOMAIN_NAME}engineering`}><strong>Engineering consultancy Services:-</strong></a> Providing technical consultancy to the member cooperatives. BENFED is actively 
        involved in construction and maintenance of Agri-Infrastructure as been undertaken by Department of co-operation, Government of West Bengal. 
        BENFED manages huge storage space in its godowns mostly strategically located throughout the state used for own business purpose or been rented 
        to generate critical revenue. <a href={`${DOMAIN_NAME}ware-house`}><strong>Link to Storage</strong></a></li>
    </ul>
    <p>We are eager to explore every shell of cooperative structure through our service which results in strengthening of economic prospects of engaged hands.</p>


    </div>
    {/* <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div> */}

    </div>
    </div>

    </>
  )
}

export default OurMission